import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useNavigation } from '@react-navigation/native'
import { AppRoutes } from 'navigations/app-routes'
import EmployeeList from 'components/organisms/EmployeeList'
import i18n from 'utils/i18n'
import selectFavourites from 'services/redux/data/selectors/selectFavourites'

const FavouritesTab = () => {
	const navigation = useNavigation();
	
	const _favourites = useSelector( selectFavourites )
	
	const filterFavourites = _.filter( _favourites, { is_favourite: 'yes' } );
	
	const openEmployee = useCallback(
		( employee ) => {
			navigation.navigate( AppRoutes.COWORKERS_VIEW, {
				employee: employee.guid
			});
		},
		[ _favourites ]
	);
	
	return (
		<EmployeeList
			employees={ filterFavourites }
			onPress={ openEmployee }
			showHeart={ true }
			showDetails={ true }
			noResultText={ i18n.t( 'pages.coworker_favourites.no_favourites' ) }
		/>
	);
}

export default FavouritesTab
